import React, { useState } from "react";

interface LabRequestFormProps {
  initialData?: any;
  onSave: (data: any) => void;
  onCancel: () => void;
}

const LabRequestForm: React.FC<LabRequestFormProps> = ({
  initialData,
  onSave,
  onCancel,
}) => {
  const [formData, setFormData] = useState({
    tests: initialData?.tests || [],
    status: initialData?.status || "pending",
  });
  const [newTest, setNewTest] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.tests.length === 0) {
      alert("Please add at least one test");
      return;
    }
    onSave(formData);
  };

  const addTest = () => {
    if (newTest.trim()) {
      setFormData({
        ...formData,
        tests: [...formData.tests, newTest.trim()],
      });
      setNewTest("");
    }
  };

  const removeTest = (index: number) => {
    setFormData({
      ...formData,
      tests: formData.tests.filter((_: string, i: number) => i !== index),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Request Tests
        </label>
        <div className="flex gap-2 mt-1">
          <input
            type="text"
            value={newTest}
            onChange={(e) => setNewTest(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addTest();
              }
            }}
            className="flex-1 block rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="Enter test name"
          />
          <button
            type="button"
            onClick={addTest}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
          >
            Add
          </button>
        </div>
        {formData.tests.length > 0 && (
          <ul className="mt-2 space-y-1">
            {formData.tests.map((test: string, index: number) => (
              <li
                key={index}
                className="flex justify-between items-center p-2 bg-gray-50 rounded"
              >
                <span className="text-sm text-gray-700">{test}</span>
                <button
                  type="button"
                  onClick={() => removeTest(index)}
                  className="text-sm text-red-600 hover:text-red-900"
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Status
        </label>
        <select
          value={formData.status}
          onChange={(e) =>
            setFormData({ ...formData, status: e.target.value })
          }
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
        >
          <option value="pending">Pending</option>
          <option value="in_progress">In Progress</option>
          <option value="completed">Completed</option>
        </select>
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          Save Request
        </button>
      </div>
    </form>
  );
};

export default LabRequestForm;

